module.exports = "/_next/static/images/energy-rebates-47e8bbf692c39d5b4d4d2c06cd73e7c1.webp";